import React, { FC, useCallback, useState, useEffect, useContext } from 'react'
import { modalLayer, getHistoryNew } from '@utils'
import { observer } from 'mobx-react'
import { Price, ProductImage, Stepper, Tags } from 'components'
import { MallController } from '@ctrls/mallController'
import { classNames } from '@dt/fe-utils'
import Config from 'common/config/config'
import MonthSaleInfo from '../MonthSaleInfo'
import './index.scss'

// interface
type TProductItem = 'waterfall' | 'recommend' | 'classic' | 'list' | 'advert';
interface IProps {
  type?: TProductItem;
  product: IMallViewProduct;
  style?: any;
  count?: number;
  lazy?: boolean;
  backgroundMode?: 'light' | 'dark';
  imgLoaded?: boolean;
  decorate?: IMallGlobalDecorates;
}
// 瀑布流图片的宽度
const ProductItem: FC<IProps> = ({ type = 'waterfall', product, style, count, lazy = false, decorate, imgLoaded = false }) => {
  const [defaultImg, setDefault] = useState<string>('')
  let { no, name, price, actualPrice, memberPrice, saleCnt, offPrice, isMemberDiscount, isCanTogo } = product || {}
  const ecolor = Config.colorImages[product.no?.charCodeAt(0) % 4]
  const soldout = saleCnt === 0
  /** 获得图片的宽高 */
  const [productStyle] = useState(() => {
    const imgWidth = (window.innerWidth - 2) / 2
    const imgHeight = imgWidth * Number(product.picHeight || 360) / Number(product.picWidth || 360)
    return {
      width: imgWidth,
      height: imgHeight
    }
  })

  useEffect(() => {
    const imgArr = JSON.parse(product.pics || '[]')
    const defaultItem = imgArr.filter(item => item.default !== 0)
    const defaultImgUrl: string = defaultItem.length ? (defaultItem[0].type === 'video' ? defaultItem[0].videoImageUrl : product.pic) : product.pic

    setDefault(defaultImgUrl)
  }, [product])

  const handleProductDetail = (product: IMallViewProduct | IViewCartItem) => {
    MallController.goToProduct(product)
  }

  return (
    <div
      className={classNames(
        'mall-product-item waterfall',
        type,
        {
          'sold-out': soldout,
        }
      )}
      style={style ? {
        // visibility: style.left ? 'visible' : 'hidden',
        left: style.left,
        top: style.top
      } : null}
      id={type + 'product' + no}
      onClick={() => handleProductDetail(product)}
    >
      {/* {
        !defaultImg
          ? (
            <div
              className='watercolor' style={{
                backgroundColor: ecolor
              }}
            >
            </div>
          ) : (
            <ProductImage
              color={!defaultImg ? product.no : ''}
              imgSrc={(imgLoaded || !lazy) ? defaultImg : ''}
              width={productStyle.width}
              height={productStyle.height}
              className={type === 'waterfall' ? 'waterfall-img' : ''}
            />
          )
      } */}
      <ProductImage
        // color={!defaultImg ? product.no : ''}
        type='mall'
        imgSrc={(imgLoaded || !lazy) ? defaultImg : ''}
        width={productStyle.width}
        height={productStyle.height}
        className={type === 'waterfall' ? 'waterfall-img' : ''}
      />
      <div className='product-info'>
        <div className='product-name'>{name}</div>
        <Tags datas={[...(product.tags || [])]} />
        <div className='product-actions'>
          {!soldout &&
            <Price
              className='product-price'
              price={price}
              fontSize={12}
              fontWeight='nomarl'
              actualPrice={actualPrice}
              hideMarketPrice={!!count}
              soldOut={soldout}
              offPrice={offPrice}
              memberPrice={memberPrice}
              isMemberDiscount={isMemberDiscount}
            />}
          {
            soldout && <span className='sold-out-msg'>{i18n.t('common.soldout')}</span>
          }
          <MonthSaleInfo showMonthSales={decorate?.showMonthSales} statSaleCnt={product.statSaleCnt} statAvatar={product.statAvatar} />
        </div>
      </div>
    </div>
  )
}
export default observer(ProductItem)
